import { Ruler } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANDING_CONTENT } from "../content";
import { PhotoSlot } from "./PhotoSlot";
import { Reveal } from "./Reveal";
import { Section, SectionHeading, SectionLead } from "./Section";

// In-scale / lifestyle: the pillow held in a hand or resting on a sofa, so it
// reads as a real object in a real home, not a floating mockup (Baymard: a
// floating product reads "cheap"; in-context context converts). Image + a short
// "what it feels like in your home" story.
export function InScale() {
  const { t } = useTranslation("landing");
  const points = t("inscale.points", { returnObjects: true }) as string[];
  return (
    <Section id="inscale" labelledBy="inscale-heading" className="bg-paper">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <Reveal>
          <PhotoSlot
            image={LANDING_CONTENT.lifestyle}
            alt={t("inscale.imageAlt")}
            briefId="inScale"
            aspectClassName="aspect-[3/2]"
            icon={Ruler}
            label={t("inscale.imagePlaceholder")}
          />
        </Reveal>
        <Reveal delayMs={100}>
          <div className="max-w-lg">
            <SectionHeading id="inscale-heading">{t("inscale.heading")}</SectionHeading>
            <SectionLead className="mt-4">{t("inscale.lead")}</SectionLead>
            {Array.isArray(points) ? (
              <ul className="mt-6 space-y-3">
                {points.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <span
                      aria-hidden="true"
                      className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary"
                    />
                    <span className="text-pretty leading-relaxed text-foreground/80">{point}</span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
